import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, CircularProgress, Paper, ButtonGroup, Button } from "@mui/material";
import { Dialpad, Add } from "@mui/icons-material";
import DialPad from "./Dialpad";
import SearchBar from "./Searchbar";
import RecruiterList from "../Voicecall/RecruiterList";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { getMyRecruitersAction } from "../../redux/action";
import { userSelector } from "../../user-redux/selector";
import { Call, CallReceived, CallMade } from "@mui/icons-material";
import TeamOverview from "./Teamoverview";

const Voicecall = () => {
  const dispatch = useDispatch();
  const { myRecruiters, error } = useSelector(appSelector);
  const [selectedContact, setSelectedContact] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dialNumber, setDialNumber] = useState("");
  // const [showDialPad, setShowDialPad] = useState(false);
  const [connections, setConnections] = useState([]);
  const [loadingRecruiters, setLoadingRecruiters] = useState(true);
  const { user } = useSelector(userSelector);

  useEffect(() => {
    if (user?.companyid) {
      setLoadingRecruiters(true);
      const rec_data = { company_id: user?.companyid };
      dispatch(getMyRecruitersAction(rec_data));
    }
  }, [dispatch, user?.companyid]);

  useEffect(() => {
    if (myRecruiters && Array.isArray(myRecruiters)) {
      setConnections(myRecruiters);
      setLoadingRecruiters(false);
    } else {
      setLoadingRecruiters(false);
    }
  }, [myRecruiters]);

  const handleCall = () => {
    if (dialNumber) {
      alert(`Calling ${dialNumber}...`);
      setDialNumber("");
    }
  };

  const safeSearchTerm = searchTerm?.toLowerCase() || "";
  const filteredConnections = connections.filter((connection) =>
    connection.recruiter_name?.toLowerCase().includes(safeSearchTerm)
  );

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Left Panel - Fixed */}
      <Box
        sx={{
          width: 300,
          background: "#fff",
          padding: 1,
          borderRight: "1px solid #ddd",
          height: "100vh",
          overflowY: "auto",
          position: "fixed",
          left: "96px",
          top: "auto"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="body1" fontWeight="bold">Recruiters</Typography>
        </Box>

        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />

        {loadingRecruiters && !connections?.length && (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Box sx={{ color: "red", textAlign: "center" }}>
            <Typography>{`Error: ${error}`}</Typography>
          </Box>
        )}

        {!loadingRecruiters && !error && filteredConnections.length > 0 && (
          <RecruiterList
            connections={filteredConnections}
            searchTerm={searchTerm}
            selectedContact={selectedContact}
            setSelectedContact={setSelectedContact}
          />
        )}
      </Box>

      {/* Right Panel - Scrollable */}
      <Box
        sx={{
          flex: 1,
          background: "#f8f9fa",
          padding: "0px 0px 0px 1px",
          marginLeft: "300px",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <TeamOverview
          connections={filteredConnections}
          selectedContact={selectedContact}
          setSelectedContact={setSelectedContact}
        />

        {/* <Paper sx={{ position: "absolute", top: 16, right: 16, padding: 1, boxShadow: 3 }}>
          <ButtonGroup variant="text" aria-label="Basic button group">
            <Button sx={{ textTransform: "none" }}>
              <Call sx={{ mr: 1 }} /> All Calls
            </Button>
            <Button sx={{ textTransform: "none" }}>
              <CallReceived sx={{ mr: 1 }} /> Incoming Calls
            </Button>
            <Button sx={{ textTransform: "none" }}>
              <CallMade sx={{ mr: 1 }} /> Outgoing Calls
            </Button>
          </ButtonGroup>
        </Paper> */}
      </Box>
    </Box>

  );
};

export default Voicecall;
